import { render, staticRenderFns } from "./DetectInfo.vue?vue&type=template&id=6d445269&scoped=true&"
import script from "./DetectInfo.vue?vue&type=script&lang=js&"
export * from "./DetectInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetectInfo.vue?vue&type=style&index=0&id=6d445269&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d445269",
  null
  
)

export default component.exports